'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'cherries';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = 'M261.9 0L172.1 209.5c-17.4-11.1-38-17.5-60.1-17.5-61.9 0-112 50.1-112 112 0 97.2 86 176 192 176s192-78.8 192-176c0-61.9-50.1-112-112-112-15.6 0-30.5 3.2-44 9L292.8 49.8 407.3 218.5c15.7 24.7 24.7 54.1 24.7 85.5 0 70.8-34.3 131.9-86.8 172.4 12.5 2.4 25.5 3.6 38.8 3.6 106 0 192-78.8 192-176 0-61.9-50.1-112-112-112-5.4 0-10.7 .4-15.9 1.1L317 0 261.9 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;